export class AdditionalCapacityInfoModel {
  public id: string;
  public name: string;
  public venueId: string;
  public fromDate: string;
  public toDate: string;
  public fromTime: string;
  public toTime: string;
}
